// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"39d23746","644":"1484f3bd","667":"9f5bc1d2"}[chunkId] + ".chunk.js";
};